import { useAuth } from 'drycut-auth';
import { PropsWithChildren } from 'react';
import { NavLink, useLocation } from 'react-router';
import { Button, Stack } from 'ui-components';
import { PageLoading } from './PageLoading';
import { DashboardHeader } from './DashboardHeader';
import { StoreProvider } from './useStoreContext';

export function StoreAdminLayout({ children }: PropsWithChildren): React.ReactElement {
  const { currentSlug } = useAuth();
  const location = useLocation();

  const getActionButton = () => {
    if (location.pathname === '/dashboard') {
      return (
        <Button className="w-52" fill="outlined" as={NavLink} to="/queue">
          Queue
        </Button>
      );
    } else {
      return (
        <Button className="w-52" fill="outlined" as={NavLink} to="/dashboard">
          Dashboard
        </Button>
      );
    }
  };

  if (!currentSlug) {
    return <PageLoading />;
  }

  return (
    <Stack className="p-6 h-screen">
      <StoreProvider>
        <DashboardHeader actionButton={getActionButton()} />

        <hr className="my-6 border-primary-600/10" />

        {children}
      </StoreProvider>
    </Stack>
  );
}
